import React, { CSSProperties } from "react";

import Note from "@mapmycustomers/shared/types/entity/common/Note";

import styles from "./ListItem.module.scss";
import NoteItem, { NoteItemProps } from "./NoteItem";

export interface ListData
  extends Omit<NoteItemProps, "deleteLoading" | "index" | "note" | "saveLoading"> {
  deleteLoadingIds: Note["id"][];
  notes: Note[];
  updateLoadingIds: Note["id"][];
}

interface Props {
  data: ListData;
  index: number;
  style: CSSProperties;
}

const ListItem: React.FC<Props> = ({ data, index, style }) => {
  const { deleteLoadingIds, notes, updateLoadingIds, ...otherProps } = data;
  const note = notes[index];
  return (
    <div className={styles.container} style={style}>
      <NoteItem
        deleteLoading={deleteLoadingIds.includes(note.id)}
        index={index}
        note={note}
        saveLoading={updateLoadingIds.includes(note.id)}
        {...otherProps}
      />
    </div>
  );
};

export default ListItem;
